import gql from 'graphql-tag';

export const GET_RENTER_CONFIRMATION_AGREEMENT = gql`
  query GetRenterConfirmationAgreement($input: RenterConfirmationAgreementReadInput) {
    getRenterConfirmationAgreement(input: $input) {
      agreement {
        id
        userId
        orderId
        eventId
        createdAt
        updatedAt
        confirmed
      }
      error
    }
  }
`;
